/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SearchSortOrder, SearchV2SortField } from "~/generated/graphql";
import { SortDirection, SortSelector, Option } from "~/components";

const SELECT_OPTIONS = [
  {
    value: SearchV2SortField.Cost,
    label: "Monthly Costs",
  },
  {
    value: SearchV2SortField.Type,
    label: "Type/Subtype",
  },
  {
    value: SearchV2SortField.Region,
    label: "Region",
  },
  {
    value: SearchV2SortField.ProviderId,
    label: "Resource name",
  },
  {
    value: SearchV2SortField.SavingsAmount,
    label: "Savings amount",
  },
];

type Props = {
  sortField: string;
  sortDirection: SearchSortOrder;
  onSortSelect: (value: SearchV2SortField) => void;
  onSortOrderChange: (value: SortDirection) => void;
  options?: Option[];
};

export function EstateSortV2({
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
  options = SELECT_OPTIONS,
}: Props) {
  return (
    <SortSelector
      options={options}
      value={sortField}
      direction={
        sortDirection === SearchSortOrder.Asc
          ? SortDirection.Ascending
          : SortDirection.Descending
      }
      onSelect={(filter) => onSortSelect(filter as SearchV2SortField)}
      onSortChange={onSortOrderChange}
    />
  );
}
